module.exports = __webpack_public_path__ + "img/zoo.56fd7516.webp";